import { __decorate } from "tslib";
import { Options } from 'vue-class-component';
import Login from './login/Login.vue';
import { WebsiteViewModel } from '@/viewmodel/WebsiteViewModel';
let WebsiteIndex = class WebsiteIndex extends WebsiteViewModel {};
WebsiteIndex = __decorate([Options({
  components: {
    Login
  }
})], WebsiteIndex);
export default WebsiteIndex;